import React from 'react'

import { Upload } from 'antd'
import { faLink } from '@fortawesome/pro-solid-svg-icons'
import { isFunction } from 'lodash'

import { onError } from '../../../utils/apiHelper'
import { useSelector } from 'react-redux'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import TooltipIconButton from '../Buttons/TooltipIconButton'

const MAX_FILE_SIZE_MB = 2

const ButtonUploader = ({ className, files, text, title, onUpload, onRemove }) => {
  const t = useSelector(selectTranslate)

  const handleUpload = (file) => {
    if (isFunction(onUpload)) {
      if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
        onError(t('files_uploader.file_too_large', { size: MAX_FILE_SIZE_MB }))
      } else {
        onUpload(file)
      }
    }

    return false
  }

  return (
    <Upload
      className={className}
      fileList={files}
      beforeUpload={handleUpload}
      onRemove={onRemove}
    >
      <TooltipIconButton icon={faLink} text={text} size='small' title={title} className={className} />
    </Upload>
  )
}

export default ButtonUploader
